import { Keys, Scene } from "excalibur";
import { Player } from "../../player";
import { OpenHive } from "../../actors/openHive";
import {
  hiveState,
  inventoryState,
  playerState,
} from "../../state/stateManager";
import { createGainedItem, sendAlert, startStingTimer } from "../../utils";
import { goToScene } from "../../main";
import { Resources } from "../../Resources";

export default class FeedMenu extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;

    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 2;
    this.playerAnim = false;
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }

  onActivate(data) {
    console.log("data from activation: ", data);
    this.hiveStats = data.data;

    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);

    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.feedMenu = document.getElementById("feed-menu");
    console.log("feedMenu: ", this.feedMenu);
    this.feedMenu.style.display = "block";
    this.feedMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
    
    ${showFeedMenu(0)}
    `;
    if (this.hiveStats.alive) {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "menu",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.stopTimer();
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onDeactivate() {
    this.stingTimer && this.stingTimer.stop();
    this.selected = null;
    this.activeItem = 0;
    this.hive.kill();
  }
  onPreUpdate() {
    if (!this.playerAnim) {
      this.player.doAnim("leftIdleBobble");
    } else {
      this.player.doAnim("addBox");
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      console.log("pressed x should go back");
      //go back
      this.feedMenu.style.display = "none";
      this.menuContainer.style.display = "none";
      this.selected = null;
      this.activeItem = 0;
      goToScene("hiveMenu", this.hiveStats);
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      let inventory = inventoryState.getInventory();
      if (this.activeItem === 0) {
        //feed 1lb
        if (inventory.sugar >= 2) {
          console.log("hive from state : ", this.hiveStats);
          let foodFrames = this.hiveStats.foodFrames;
          foodFrames.count = foodFrames.count + 0.2;
          let hives = hiveState.getHives();
          hives.forEach((hive, i) => {
            if (hive.id == this.hiveStats.id) {
              console.log("got hive");
              hive.foodFrames = foodFrames;
            }
          });
          inventory.sugar = inventory.sugar - 2;
          inventoryState.setInventory(inventory);
          hiveState.setHives(hives);
          Resources.Feed.play();
          createGainedItem("Fed 1lb of Syrup!");
        } else {
          sendAlert("Not Enough Supply", () => {});
        }
      } else {
        //feed 2lb
        if (inventory.sugar >= 4) {
          console.log("hive from state : ", this.hiveStats);
          let foodFrames = this.hiveStats.foodFrames;
          foodFrames.count = foodFrames.count + 0.4;
          let hives = hiveState.getHives();
          hives.forEach((hive, i) => {
            if (hive.id == this.hiveStats.id) {
              console.log("got hive");
              hive.foodFrames = foodFrames;
            }
          });
          inventory.sugar = inventory.sugar - 4;
          inventoryState.setInventory(inventory);
          hiveState.setHives(hives);
          Resources.Feed.play();
          createGainedItem("Fed 2lb of Syrup!");
        } else {
          sendAlert("Not Enough Supply", () => {});
        }
      }
    }
    this.feedMenu.innerHTML = `<h1>Hive: ${
      this.hiveStats.id
    }</h1>${showFeedMenu(this.activeItem)}`;
  }
}
function showFeedMenu(active) {
  if (active === 0) {
    return `<h3>Feed Hive</h3><ul>
        <li id="list0"><span id="selector">></span>Feed 1lb Syrup</li>
        <li id="list1">Feed 2lb Syrup</li>
      
      </ul>`;
  } else {
    return `<h3>Feed Hive</h3><ul>
        <li id="list0">Feed 1lb Syrup</li>
        <li id="list1"><span id="selector">></span>Feed 2lb Syrup</li>
      
      </ul>`;
  }
}
